module.exports = __webpack_public_path__ + "static/media/face-rec-app.f4294e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/face-rec-app.png
// module id = 44
// module chunks = 0